module.exports = __webpack_public_path__ + "img/endless-clouds-white.b01fd5f1.svg";